<template>
  <app-left-right>
    <template #left>
      <user-tree-list @sendOgr="sendOgr"></user-tree-list>
    </template>
    <template #right>
      <app-base-main parentTable :no-padding="true">
        <template #filter-group>
          <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
            <gj-select :options="disableOption" v-model="status"> </gj-select>
            <gj-select-input v-model="keyword" :options="userDynamicKeyOption">
            </gj-select-input>
          </app-filter-group>
        </template>
        <template #operate-group>
          <gj-button
            type="primary"
            @click="openEditModal(null),userGuideNextStep()"
            v-if="$permission('user:add')"
          >
            添加用户
          </gj-button>
        </template>
        <template #tool-group>
          <gj-tool-group
            setting
            :table-name="name"
            :table-columns="columns"
            :sort-gjtable="$refs.gjTable"
            help
          >
          </gj-tool-group>
        </template>
        <template #table>
          <gj-table
            ref="gjTable"
            adaptParent
            :columns="columns"
            :data="tableData"
            selection
            :offset-height="16"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
            :pagination="pagination"
            :loading="loading"
          >
            <template v-slot:org="{ row }">
              <gj-tooltip
                :text-line="1"
                :content="row.org.data != null ? row.org.data.label : '-'"
              >
                {{ row.org.data != null ? row.org.data.label : "-" }}
              </gj-tooltip>
            </template>
            <template v-slot:email="{ row }">
              <gj-tooltip
                :text-line="1"
                :content="row.email != null ? row.email : '-'"
                >{{ row.email != null ? row.email : "-" }}
              </gj-tooltip>
            </template>
            <template v-slot:status="{ row }">
              <span v-if="row.status.code === 'DISABLE'" style="color: red">
                停用
              </span>
              <span v-if="row.status.code === 'ENABLE'" style="color: #444">
                启用
              </span>
            </template>
            <template v-slot:roleName="{ row }">
              <gj-tooltip
                :text-line="1"
                :content="row.roleName != null ? row.roleName : '-'"
                >{{ row.roleName != null ? row.roleName : "-" }}
              </gj-tooltip>
            </template>
            <template v-slot:authMarket="{ row }">
              <gj-tooltip
                :text-line="1"
                :content="row.authMarket != null ? row.authMarket : '-'"
                >{{ row.authMarket != null ? row.authMarket : "-" }}
              </gj-tooltip>
            </template>
            <template v-slot:op="{ row }">
              <gj-button-group type="dropdown-op">
                <template
                  v-if="
                    row.accountType.code !== 'MAIN' ||
                      (row.accountType.code === 'MAIN' &&
                        userInfo.userId === row.id)
                  "
                >
                  <gj-button
                    type="text"
                    @click="
                      openEditModal(row.id, row.accountType.code === 'MAIN'),
                      userGuideCancel()
                    "
                    v-if="$permission('user:update')"
                    >编辑</gj-button
                  >
                </template>
                <template v-if="row.accountType.code !== 'MAIN'">
                  <gj-button
                    type="text"
                    @click="
                      operatorDisable(
                        row,
                        !(row.status.code === 'ENABLE') ? 'ENABLE' : 'DISABLE',
                        !(row.status.code === 'ENABLE') ? '启用确认' : '停用确认'
                      )
                    "
                    v-if="$permission('user:upStatus')"
                    >{{ !(row.status.code === "ENABLE") ? "启用" : "停用" }}
                  </gj-button>
                </template>
              </gj-button-group>
            </template>
          </gj-table>
        </template>
        <template v-if="userGuideState" #base-content>
          <new-user-management-guidelines ref="newUserGuide" @closeModal="closeModal"></new-user-management-guidelines>
        </template>
      </app-base-main>
    </template>
  </app-left-right>
</template>

<script>
import { userDisableOption,userDynamicKeyOption } from "../../../../utils/options";
import UserEditModal from "./modal/user-edit-modal";
import userHandleModal from "./modal/user-handle-modal";
import UserTreeList from "./component/user-tree-list";
import { queryMixin, selectionMixin, userGuideMixin} from "../../../../minxins";
import { userPage, userDetail, editUser, upUserStatus, addUser } from "../../../../api/setting";
import { mapGetters } from "vuex";
import { isMeaningful } from "../../../../utils/common";
import { USER_GET_ACTIVE_USER_OPTIONS, USER_GET_USER_OPTIONS } from "../../../../store/action-types";
import NewUserManagementGuidelines from "./component/new-user-management-guidelines";

export default {
  name: "app-user",
  components: { UserTreeList, NewUserManagementGuidelines },
  mixins: [queryMixin, selectionMixin, userGuideMixin],
  computed: {
    ...mapGetters({
      userInfo: "userInfo",
    }),
  },
  activated() {
    // 更新新增修改弹框的角色option
    if(this.modal) {
      this.modal.queryRole()
    }
  },
  data() {
    return {
      name: "user",
      status: "ENABLE",
      disableOption: userDisableOption,
      userDynamicKeyOption: userDynamicKeyOption,
      keyword: {
        key: "userName",
        value: null,
      },
      orgId: null,
      sortTable: null,
      columns: [
        {
          id: "userName",
          header: "用户名",
          fixed: "left",
          field: "userName",
          minWidth: "120px",
          notCustomColumn: true,
        },
        {
          id: "name",
          header: "真实姓名",
          fixed: "left",
          field: "name",
          minWidth: "80px",
          notCustomColumn: true,
        },
        {
          id: "phone",
          header: "手机号码",
          fixed: "left",
          field: "phone",
          minWidth: "120px",
          notCustomColumn: true,
        },
        {
          id: "email",
          header: "邮箱",
          field: "slot:email",
          minWidth: "120px",
          default: true,
        },
        {
          id: "org",
          header: "部门",
          field: "slot:org",
          minWidth: "120px",
          default: true,
        },
        {
          id: "roleName",
          header: "角色",
          field: "slot:roleName",
          minWidth: "120px",
          default: true,
        },
        {
          id: "authMarket",
          header: "授权店铺",
          field: "slot:authMarket",
          minWidth: "150px",
          default: true,
        },
        {
          id: "status",
          header: "状态",
          field: "slot:status",
          minWidth: "50px",
          default: true,
        },
        {
          id: "createTime",
          header: "创建时间",
          field: "createTime",
          minWidth: "170px",
          default: true,
        },
        // {id: 'loginNum', header: '登录次数', field: 'loginNum', minWidth: '100px', default: true},
        {
          id: "lastLoginTime",
          header: "最近登录时间",
          field: "lastLoginTime",
          minWidth: "170px",
          default: true,
        },
        {
          id: "createName",
          header: "创建用户",
          field: "createName",
          minWidth: "120px",
          default: true,
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          width: "120px",
          fixed: "right",
          notCustomColumn: true,
        },
      ],
      tableData: [],
      modalVisible: {
        operator: false,
        edit: false,
        logModal: false,
      },
      logId: null,
      disableLoading: false,
    };
  },
  methods: {
    $gjReset() {
      this.keyword = {
        key: "userName",
        value: null,
      };
      this.status = "ENABLE";
      this.$gjNoticeQuery();
    },
    operatorDisable(row, status,title) {
      const vm = this;
      const modal = this.$gjCreate(userHandleModal, {
        props: {
          operatorRow: row,
          title:title
        },
        on: {
          confirm() {
            modal.loading = true;
            const params = {
              id: row.id,
              status,
            };
            upUserStatus(params)
              .then((response) => {
                if (response.isSuccess) {
                  vm.$message.success("操作成功");
                  vm.$emit("query");
                  vm.refreshUserStore();
                  modal.$gjDestroy();
                } else {
                  vm.$message.error(response.msg);
                }
              })
              .complete(() => (modal.loading = false));
          },
        },
      });
    },
    closeModal() {
      if(this.modal)  {
        this.isAutoModal = true; // 是否为主动销毁
        this.modal.$gjDestroy();
        this.modal = null;
      }
    },
    openEditModal(id, isMain = false) {
      this.modal = this.$gjCreate(UserEditModal, {
        props: {
          id: id,
          isMain: isMain,
          orgId: this.orgId,
        },
        on: {
          create: (item) => {
            this.modal.loading = true;
            const datas = [];
            const roles = [];
            for (let i = 0; i < item.datas.length; i++) {
              var obj1 = item.datas[i];
              datas.push({
                id: obj1,
              });
            }
            for (let i = 0; i < item.roles.length; i++) {
              var obj2 = item.roles[i];
              roles.push({
                id: obj2,
              });
            }
            item.datas = datas;
            item.roles = roles;
            if (item.id != null && item != 0 && item.id != "") {
              editUser(item)
                .then((response) => {
                  if (response.isSuccess) {
                    this.$message.success("操作成功");
                    this.$emit("query");
                    this.refreshUserStore();
                    this.modal.$gjDestroy();
                    this.modal = null;
                  } else {
                    this.$message.error(response.msg);
                  }
                })
                .complete(() => {
                  if(this.modal) {
                    this.modal.loading = false;
                  }
                });
            } else {
              addUser(item)
                .then((response) => {
                  if (response.isSuccess) {
                    this.$message.success("操作成功");
                    this.$emit("query");
                    this.refreshUserStore();
                    if(this.userGuideState) {
                      this.isAutoModal = true;
                      this.userGuideNextStep()
                    }
                    if(this.modal) {
                      this.modal.$gjDestroy();
                      this.modal = null;
                    }
                  } else {
                    this.$message.error(response.msg);
                  }
                })
                .complete(() => {
                  if(this.modal) {
                    this.modal.loading = false;
                  }
                });
            }
          },
          close: () => {
            if(!this.isAutoModal) { // 非自动关闭弹框才需要退出用户指引模式
              // 关闭引导用户
              this.userGuideCancel();
              this.isAutoModal = false;
            }
            this.modal = null;
          },
        },
      });
    },
    refreshUserStore() {
      this.$store.dispatch(USER_GET_ACTIVE_USER_OPTIONS);
      this.$store.dispatch(USER_GET_USER_OPTIONS);
    },
    openLog(id) {
      this.logId = id;
      this.modalVisible.logModal = true;
    },
    upUserStatus() {
      this.disableLoading = true;
      const params = {
        id: this.operatorRow.id,
        status: this.operatorStatus,
      };
      upUserStatus(params)
        .then((response) => {
          if (response.isSuccess) {
            this.$message.success("操作成功");
            this.$emit("query");
            this.modalVisible.operator = false;
            this.refreshUserStore();
          } else {
            this.$message.error(response.msg);
          }
        })
        .complete(() => (this.disableLoading = false));
    },
    cancel() {
      this.modalVisible.edit = false;
    },
    $gjQuery() {
      // 分页查询
      this.loading = true;
      const params = {
        model: {
          status: this.status,
          name: this.keyword.key === "name" ? this.keyword.value : null,
          userName: this.keyword.key === "userName" ? this.keyword.value : null,
          phone: this.keyword.key === "phone" ? this.keyword.value : null,
          org: {
            key: this.orgId,
          },
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      userPage(params)
        .then((response) => {
          this.tableData = response.data.records;
          this.pagination = this.getPagination(response.data);
        })
        .complete(() => {
          this.loading = false;
        });
    },
    sendOgr(data) {
      if (isMeaningful(data)) {
        this.orgId = data.id;
      } else {
        this.orgId = null;
      }
      this.$emit("query");
    },
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.body {
  flex: 1;
}

/deep/ .el-tabs__nav-wrap {
  padding-left: 20px;
}
</style>
